<div class="adminuicontainer flex h-screen flex-row">
  <!-- Left fixed menu -->
  <div class="main-menu border-r-2 border-solid-grey overflow-y-auto">
    <app-menu [menuArray]="menu"></app-menu>
  </div>

  <!-- Right scrollable content -->
  <div class="main-content flex flex-col flex-1 overflow-hidden">
    <!-- Fixed header -->
    <div
    [ngClass]="{
      'hidden': isHeaderHidden,
      'visible flex justify-between px-6 py-6 backdrop-blur-md bg-white/30 border-b border-white/20 shadow-md': !isHeaderHidden
    }"
     >
      <!-- <app-header-adminui
        [user]="user"
        [domainName]="domainNameMessage"
      ></app-header-adminui> -->
      <h1>{{user}}</h1>
      <span nz-tooltip nzTooltipTitle="Logout">
      <span nz-icon nzType="logout" nzTheme="outline" (click)="logout()" ></span>
      </span>
    </div>

    <!-- Scrollable main content area -->
    <div class="contentadminui flex-1 overflow-y-auto md:p-4">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
